import SyncIcon from '@mui/icons-material/Sync';
import type { ResourceProps } from 'react-admin';
import { DashboardResources } from '@src/types';

import QueueStatusList from './QueueStatusList';

const shopifySyncResource: Omit<ResourceProps, 'children'> = {
  name: DashboardResources.ShopifySync,
  list: QueueStatusList,
  icon: SyncIcon,
  options: { label: 'Queue Status' },
};

export default shopifySyncResource;

export { shopifySyncDataProvider } from './dataProvider';
